import { createModule } from '@dynapp/wc-api-generic'

export default createModule({
  entitySingular: 'zreport',
  entityPlural: 'zreports',
  dataObject: 'dync-appshop-web',
  mode: process.env.NODE_ENV
});
